export default class Recipes {
	constructor() {
		this.initEvents();
	}

	initEvents() {
		return $('.filter select').on('change', function (e) {

			$('.load-more__button').attr('data-page', 0);
			$('.load-more__button').show();

			// recipetype = $('select[name="recipetype"] option:selected
			const recipetype = $('select[name="recipetype"]').val();
			const dishtype = $('select[name="dishtype"]').val();
			const cooktime = $('select[name="cooktime"]').val();
			const popular = $('select[name="popular"]').val();

			return $.ajax({
				type: 'POST',
				headers: { 'X-CSRF-TOKEN': $('input[name="_token"]').val() },
				data: { recipetype, dishtype, cooktime, s: popular },
				url: window.site.base_url + '/api/getsearchrecipe',
				success: (data, status, xhr) => {

					$('.news-grid').remove();
					const elements = jQuery(data);
					const last = elements.last()[0].value;

					elements.splice(-1, 1);
					const news_grid = $('<div class="news-grid"></div>');
					$(".filter").after(news_grid);
					news_grid.append(elements);

					news_grid.masonry({
						itemSelector: '.news-item',
						columnWidth: '.news-item',
						percentPosition: true
					});

					if (!$.trim($('.news-grid').html()).length) {
						$('.news-grid').html(`<h2 class='no-content padding'>${window.site.empty_news}</h2>`);
						$('.load-more__button').hide();
					}

					if (last === '1') {
						return $('.load-more').show();
					} else {
						return $('.load-more').hide();
					}
				}
			});
		});
	}
}
